import React from "react";
import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
const Locations = dynamic(() => import("@/app/locations"), {
  ssr: false,
});

const Page = () => {
  return <Locations />;
};

export default Page;
export async function getStaticProps(context: any) {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
    revalidate: 3600,
  };
}
